// extracted by mini-css-extract-plugin
module.exports = {"banner":"ProductArchivedBanner_banner__NxZ1q","banner-text":"ProductArchivedBanner_banner-text__D_V6V","banner-icon":"ProductArchivedBanner_banner-icon__3l6Dg"};